import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import GlobalLayout from "../../components/layouts/layout-global";
import SectionDefault from "../../components/sections/section-default";
import SEO from "../../components/seo";
import HubspotForm from "../../components/forms/hubspot-forms/hubspot-form";
import NewInvestigatorBanner from "../../components/features/hero-carousel/carousel-cards/new-investigator-banner";
import ToTop from "../../components/to-top";
import AnchorHeading from "../../components/anchor-heading";
import { AccordionItemLite, AccordionLite } from "../../components/accordion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

export const Head = ({ location }) => (
  <SEO
    title="NACC New Investigator Awards"
    // prettier-ignore
    keywords={["NACC", "investigator", "awards", "Alzheimer's", "research", "grant", "NIA", "NIH", "database", "neuropathology", "LBD", "FTLD", "neurology", "gerontology", "age", "cognitive", "genetics", "APOE"]}
    description="The NACC New Investigator Award Program supports new and early-career investigators from the 37 currently active ADRCs."
    pathname={location.pathname}
  />
);

export default function NewInvestigatorAwards(props) {
  return (
    <GlobalLayout location={props.location}>
      <SectionDefault>
        <div className="uk-margin-auto" data-uk-grid="true">
          <StaticImage
            className="uk-width-1-1"
            src="../../images/new-investigators/ni-hero-2025.png"
            alt="New Investigator Award 2025"
          />
        </div>
        <div className="text-body uk-margin-large-top">
          <div className="uk-margin-left uk-margin-right">
            <div className="uk-margin-auto uk-padding-remove">
              <div className="uk-margin-auto uk-padding-remove">
                <h2 className="uk-text-primary uk-text-center">
                  Congratulations to the 2025 New Investigator Award Winners!
                </h2>
                <h3 className="uk-margin-remove uk-text-center">
                  <a
                    href="/nacc-productivity/2025-new-investigator-award-winners"
                    className="uk-button uk-button-large uk-button-text uk-text-primary text-body"
                  >
                    View the list of awardees and their projects here{" "}
                    <FontAwesomeIcon className="uk-margin-small-left" icon={faArrowRight} scale={1} />
                  </a>
                </h3>
              </div>
            </div>
            <hr />
            <div className="uk-flex uk-flex-center uk-margin-top-large">
              <div className="uk-width-1-2@s">
                <h3>Stay Informed</h3>
                <p>
                  Sign up for NIAP announcements to stay informed about the program, including access to our webinar
                  recordings with valuable insights from program leaders on developing competitive applications.
                </p>
              </div>{" "}
              <div style={{ minHeight: 300 }} className="uk-width-1-3@m">
                <HubspotForm
                  region="na1"
                  portalId="19562737"
                  formId="82be4f6d-7025-4bc8-8ab8-f89d46ad673f"
                  target="hbspt-form-2"
                />
              </div>
            </div>

            <NewInvestigatorBanner />
          </div>
        </div>
        <ToTop />
      </SectionDefault>
      {/* 
      <SectionDefault>
        <div className="text-body">
          <h2 className="uk-margin-bottom uk-heading-divider uk-text-primary">
            <AnchorHeading heading="About the New Investigator Award Program" />
          </h2>

          <h5 className="uk-text-secondary">
            <AnchorHeading heading="New Investigator Award Program Overview" />
          </h5>
          <div className="uk-margin-left uk-margin-right">
            <p>
              National Alzheimer’s Coordinating Center (NACC) is home to one of the largest, oldest, and most powerful
              Alzheimer’s Disease and Related Dementias (ADRD) datasets, built in collaboration with more than 42
              Alzheimer’s Disease Research Centers (ADRCs) throughout the US over the past 20+ years. The Alzheimer’s
              Association is the world’s largest non-profit funder of Alzheimer’s and all dementia science, with over
              $360 million in funding committed today to over 1,000 projects in 53 countries.
            </p>
            <p>
              This year, these two organizations are partnering together to offer the Alzheimer’s Association and NACC
              New Investigators Awards Program (NIAP).
            </p>
            <p>
              Up to ten (10) NIAP awards will be granted in the spring of 2024 based on the scientific merit, through
              peer-review as described below, of submitted applications. Eligible candidates include new and
              early-career investigators from the 37 currently active ADRCs. These awards aim to support the career
              development of new investigators and advance scientific research on ADRD.
            </p>
            <p>
              Funding early career investigators is a core tenant of the missions of the Alzheimer’s Association, NACC
              and the ADRCs.
            </p>
          </div>
          <div className="uk-margin-top uk-grid-small uk-flex-center uk-child-width-1-2@m" data-uk-grid="true">
            <div>
              <iframe
                src="https://www.youtube-nocookie.com/embed/cqjL7AaOZfE?start=0?autoplay=0&amp;showinfo=0&amp;rel=0&amp;modestbranding=1&amp;playsinline=0"
                width="1920"
                height="1080"
                allowfullscreen
                data-uk-responsive
                data-uk-video="false"
              ></iframe>
            </div>
            <div>
              <iframe
                src="https://www.youtube-nocookie.com/embed/i4feNnEZBdU?start=0?autoplay=0&amp;showinfo=0&amp;rel=0&amp;modestbranding=1&amp;playsinline=0"
                width="1920"
                height="1080"
                allowfullscreen
                data-uk-responsive
                data-uk-video="false"
              ></iframe>
            </div>
            <div>
              <iframe
                src="https://www.youtube-nocookie.com/embed/LoncnOnEj8s?start=0?autoplay=0&amp;showinfo=0&amp;rel=0&amp;modestbranding=1&amp;playsinline=0"
                width="1920"
                height="1080"
                allowfullscreen
                data-uk-responsive
                data-uk-video="false"
              ></iframe>
            </div>
          </div>

          <div className="uk-width-1-1 uk-flex uk-margin-large uk-flex-center uk-flex-middle">
            <div className="uk-width-2-3@s">
              <TextBoxGray>
                <div className="uk-text-center uk-text-lead bolder">
                  Read about previous award winners
                  <Link
                    className="uk-text-center uk-button uk-margin-left uk-button-primary"
                    to="/nacc-productivity/ni-award-winners-blog"
                  >
                    here
                    <FontAwesomeIcon className="uk-margin-small-left" icon={faArrowRight} scale={1} />
                  </Link>
                </div>
              </TextBoxGray>
            </div>
          </div>

          <h5 className="uk-text-secondary">
            <AnchorHeading heading="Features of a Successful New Investigator Award Program Project" />
          </h5>
          <div className="uk-margin-left uk-margin-right">
            <p>
              Successful applications must demonstrate scientific rigor. This will be determined through peer review;
              the peer-review process will evaluate the scientific merit and potential impact on the field of ADRD.
              Areas of study are open across the entire spectrum of proposed research on-going within the ADRC network,
              including but not limited to data-driven and methodological studies, if they rely on credible data
              sources. The research studies may be discovery science, translational, clinical- or care-related, and may
              include a range of methodologies including genomic studies and data science.{" "}
            </p>
            <p>
              Research proposals should advance ADRD science through new approaches that have the potential to identify
              and characterize important gaps in knowledge related to environmental exposures, social and structural
              determinants of health, biomarkers, disease mechanisms, or novel therapeutic approaches. Research
              questions may be rooted in multiple disciplines, such as neuropathology, epidemiology, neurology,
              psychiatry, gerontology/aging, psychology, imaging/radiology, pharmacology, informatics, and data
              science/biostatistics.{" "}
            </p>
            <p>
              Importantly, the research should aim to provide novel insights to our understanding, rather than
              replicating previous studies.{" "}
            </p>
          </div>

          <h5 className="uk-margin-bottom  uk-text-primary">
            <AnchorHeading heading="Funding and Award Period" />
          </h5>
          <div className="uk-margin-left uk-margin-right">
            <p>
              NACC and the Alzheimer’s Association will fund up to ten (10) awards. Each award will be for $135,000
              (direct costs) for the 2024 award cycle. New investigators can propose projects that are one to two years
              in length. For awards funded by the Alzheimer’s Association, the receiving institution’s indirect cost
              rate will be restricted to 10% on top of the direct costs. In addition to the $135K direct cost award,
              NACC will also fund the travel expenses for all 10 New Investigator awardees to present their research at
              an ADRC meeting. Additional details regarding the budget and timeline are addressed in the Application
              section below.
            </p>
            <p>
              Funding decisions will be made by the NACC Steering Committee based on the scientific merit and potential
              impact as determined by peer review of the Scientific Review Committee.
            </p>
            <p>
              The ADRC Director is expected to certify that the applicant is a “member” of their ADRC and that they will
              provide oversight of the NIAP award for the distribution of funds and/or the expenditures. NACC and the
              Alzheimer’s Association will work with the ADRC’s institutional Grants Office on the appropriate
              reporting.
            </p>
          </div>

          <section className="uk-margin-large-top uk-margin-large-bottom">
            <a id="faq"></a>
            <h5 className="uk-margin-bottom uk-text-primary">
              <AnchorHeading heading="Eligibility Requirements" />
            </h5>
            <div className="uk-margin">
              <ul className="uk-list uk-list-bullet uk-margin-left">
                <li>
                  <span className="bold uk-text-secondary">You must be a new investigator, </span>defined as
                  post-doctoral fellows, residents, or junior faculty that have not yet been promoted to associate
                  professor rank (MD or PhD), within ten years of rank, and not already having had an R01 grant.
                  Researchers and investigators with a higher or lower academic rank are not eligible to apply.
                </li>
                <li>
                  <span className="bold uk-text-secondary">
                    New investigators must be affiliated with an Alzheimer&apos;s Disease Research Center (ADRC).
                  </span>{" "}
                  ADRC Directors must provide a letter to confirm that the new investigator&apos;s ADRC affiliation was
                  in place prior to October 2023 and is ongoing. The letter must also affirm the ADRC Director&apos;s
                  commitment to distribute and provide financial oversight for the award funds. A template for the
                  letter is provided{" "}
                  <a
                    href="https://files.alz.washington.edu/new-investigator-awards/letter-of-support-example.pdf"
                    title="Letter of support example"
                  >
                    here
                  </a>{" "}
                  and in the online application materials.
                  <br />
                  If you are not eligible for this award, we encourage you to apply for other funding mechanisms, such
                  as an{" "}
                  <a href="https://grants.nih.gov/grants/guide/pa-files/PAR-23-179.html" title="RO3 Award">
                    RO3 Award
                  </a>
                  .
                </li>
              </ul>
            </div>

            <ul className="uk-accordion left-indicator" data-uk-accordion="multiple: true">
              <li>
                <div
                  style={{ cursor: "pointer" }}
                  className="uk-text-large uk-text-primary uk-accordion-title uk-margin-left uk-width-auto"
                >
                  <span>&nbsp;Eligibility and Application FAQs</span>
                </div>
                <div className="uk-accordion-content">
                  <div className="uk-flex uk-flex-center uk-width-1-1">
                    <NiEligibilityFaq />
                  </div>
                  <div className="uk-margin-top">
                    If your question is not addressed in the FAQ, please contact us at&nbsp;
                    <a className="bolder" href="mailto:info@naccdata.org">
                      info@naccdata.org
                    </a>
                  </div>
                </div>
              </li>
            </ul>
          </section>

          <h5 className="uk-margin-bottom uk-text-primary">
            <AnchorHeading heading="Data Sources" />
          </h5>
          <div className="uk-margin-left uk-margin-right">
            New Investigator projects may leverage any data source or study base but must defend its scientific rigor to
            address the research questions at hand. NACC data are NOT required to be used to NIAP proposals that allow
            the investigator to visit and/or collaborate across ADRCs to meet with experts (internal or external
            Mentors) or obtain study-specific data are encouraged.
          </div>

          <h5 className="uk-margin-bottom  uk-text-primary">
            <AnchorHeading heading="NACC-REC New Investigator Award Mentorship Program" />
          </h5>
          <div className="uk-margin-left uk-margin-right">
            <p>
              The National Alzheimer’s Coordinating Center (NACC) and the Alzheimer’s Disease Research Centers’ (ADRC)
              Research Education Component (REC) Steering Committee have partnered to provide the NACC-REC New
              Investigator Award Mentorship Program.
            </p>
            <p>
              All applicants for the New Investigator Awards Program can request a mentor via their Letter of Intent.
            </p>
            <p>Mentor and Mentee expectations:</p>
            <ul className="uk-list uk-list-bullet uk-margin-left">
              <li className="uk-inline">
                <div className="red uk-position-center-left-out uk-margin-small-right">NEW</div>
                Participate in two review and feedback sessions, which can be asynchronously, before the February 16,
                2024, application deadline
              </li>
              <li>
                Time expectation for mentors is three hours for reviewing and providing feedback on their mentee’s
                application
              </li>
            </ul>
          </div>

          <h2 className="uk-margin-bottom uk-heading-divider uk-margin-large-top uk-text-primary">
            <AnchorHeading heading="Key Dates" />
          </h2>
          <div className="uk-margin">
            <table className="uk-table uk-table-divider uk-table-middle ">
              <tbody className="text-body">
                <tr>
                  <td> Letter of Intent and Request a Mentor from the ADRC RECs Deadline* </td>
                  <td className=" text-body uk-text-secondary bolder">November 30, 2023, 5pm EST </td>
                </tr>
                <tr>
                  <td>Application Deadline*</td>
                  <td className=" text-body uk-text-secondary bolder uk-inline">
                    <div className="red uk-text-normal uk-position-center-left-out uk-margin-small-right">NEW</div>
                    <p>February 16, 2024, 5pm EST</p>
                  </td>
                </tr>
                <tr>
                  <td>Application Review </td>
                  <td className=" text-body uk-text-secondary bolder">February – April 2024 </td>
                </tr>
                <tr>
                  <td>Award Notifications </td>
                  <td className=" text-body uk-text-secondary bolder">
                    May 2024 - Award winners announced at 2024 Spring ADRC Meeting in Austin, TX{" "}
                  </td>
                </tr>
              </tbody>
            </table>
            <p className="uk-text-meta">
              *The Request for a Mentor, Letter of Intent and Application must be received by 5pm EST Time on their
              respective deadlines.
            </p>
          </div>
        </div>
        <ToTop />
      </SectionDefault>

      <SectionDefault>
        <div className="text-body">
          <h2 id="apply" className="uk-margin-bottom uk-heading-divider uk-text-primary">
            <AnchorHeading heading="Apply for a New Investigator Award" />
          </h2>
          <h5 className="uk-margin-bottom uk-text-primary">
            <AnchorHeading heading="Review Process Overview" />
          </h5>
          <div className="uk-margin-left uk-margin-right">
            <p>
              Applications undergo a thorough, multi-stage review to assess scientific and technical merit. This process
              is facilitated by the online system proposalCENTRAL and involves multiple organizations and committees
              including NACC, the Alzheimer&apos;s Association, and NACC’s Scientific Review Committee (SRC).{" "}
            </p>
            <p className="bold">Review Criteria </p>
            <ul className="uk-list uk-margin-left uk-list-bullet">
              <li>
                Overall Impact: The potential for the project to significantly influence relevant research fields.{" "}
              </li>
              <li>Significance: The importance of the project. </li>
              <li>Investigator(s): The qualifications of the research team. </li>
              <li>Innovation Approach: The novelty of the research methods. </li>
              <li>Environment: The adequacy of the research setting. </li>
              <li>Budget & Resources: Quality and suitability of the proposed budget and resources. </li>
            </ul>
            <p className="bold">Additional Criteria</p>
            <ul className="uk-list uk-margin-left uk-list-bullet">
              <li>Protections for Human Subjects </li>
              <li>Inclusion of Women, Minorities, and Children </li>
              <li>Vertebrate Animals </li>
              <li>Biohazards</li>
            </ul>
          </div>

          <h5 className="uk-margin-bottom uk-text-primary">
            <AnchorHeading heading="Review Stages (For Full Applications)" />
          </h5>
          <div className="uk-margin-left uk-margin-right">
            <p>
              <span className="bolder">First Stage</span>: NACC and the Alzheimer Association review applications for
              eligibility and completeness and assign them for peer review.
            </p>
            <p>
              <span className="bolder">Second Stage</span>: Review by the NACC Scientific Review Committee (SRC) through
              proposalCENTRAL and will include a panel of at least three peer scientists with relevant expertise. These
              reviewers will provide written commentary, scores (using NIH scale), and will engage in a thorough
              discussion of each application. The committee&apos;s evaluation centers on the criteria noted above.{" "}
            </p>
            <p>
              <span className="bolder">Overall Impact</span>: Each committee member, who has no conflict of interest,
              will assign an overall impact score after discussion in the SRC meeting. This score will reflect their
              assessment of the project&apos;s potential to significantly influence the research fields involved.{" "}
            </p>
            <p>
              The score will take into account various review criteria as well as any additional criteria relevant to
              the specific project.{" "}
            </p>
            <p>
              <i>Note</i>: Applications that initially score below the median may not be discussed during the committee
              meeting and will be marked `unscored.` However, written reviews for these applications will still be
              returned to the applicant.{" "}
            </p>
            <p className="bold">Final Approval </p>
            <p>
              Final Impact scoring and review summaries from the SRC are forwarded to the NACC Steering Committee and
              the Alzheimer&apos;s Association for final selection. This rigorous, multi-level review ensures fair and
              scientifically sound award decisions.{" "}
            </p>
            <p>
              Once finalists are identified, NACC and the Alzheimer’s Association will contact both the ADRC and the New
              Investigator to finalize the award details, including award amounts. At that time, NACC and the
              Alzheimer&apos;s Association will also provide a list of any further required documents—such as “Just in
              Time” information, including but not limited to: Other Support.{" "}
            </p>
          </div>

          <h5 className="uk-margin-bottom uk-text-primary">
            <AnchorHeading heading="Post Award Information" />
          </h5>
          <div className="uk-margin-left uk-margin-right">
            <h6 className="bold">
              <AnchorHeading heading="ETHICAL/REGULATORY APPROVALS & REPORTING REQUIREMENTS" />
            </h6>
            <p>
              If awarded funding, NACC and the Alzheimer’s Association require any necessary ethical and/or regulatory
              approvals to be kept current and may also require specific reporting throughout the lifetime of the award.
              This includes, but is not limited to, the following:{" "}
            </p>
            <p className="bold">Human Participants Assurances </p>
            <p>
              Human participants (subject) assurances are not required at the time of application. NACC and the
              Alzheimer’s Association accept only certifications that apply specifically to the funded project and must
              include the name of the awardee.{" "}
            </p>
            <p className="bold">Annual Scientific and Financial Reports </p>
            <p>
              Annual Scientific & Financial Reports must be submitted at the end of each reporting period as long as the
              grant remains active. Final Scientific & Financial Reports must be filed within 90 days of the grant end
              date. All reports must be submitted electronically via proposalCENTRAL. The Financial Report must be
              approved and signed by someone with financial authority in the Office of Research and Sponsored Programs
              at the recipient’s institution.{" "}
            </p>
            <p className="bold">Publications, Presentations and Abstracts </p>
            <p>
              Electronic copies of publications, presentations and abstracts that report research supported by funds
              from NACC and Alzheimer’s Association must be submitted electronically at the time of publication. These
              copies will become part of the official file of the grant and will be provided to the Communications
              Division of the Alzheimer’s Association and the National Alzheimer’s Coordinating Center (NACC) to assist
              in the efforts to further inform the public about the Research Grant Program of the Alzheimfer&apos;s
              Association, NACC’s New Investigator Award Program, and the Alzheimer’s Disease Research Center Program.{" "}
            </p>
            <p className="bold">Recruitment Efforts for Clinical Studies </p>
            <p>
              If your project involves human participants, your application must clearly describe your inclusion and
              exclusion criteria, as well as your efforts to recruit a diverse participant pool from the community where
              the study takes place.{" "}
            </p>
            <p>
              Upon awarding, and before fund disbursement, you will need to submit a detailed recruitment plan. This
              should outline how you&apos;ll ensure diversity across various key demographic variables, such as sex,
              gender identity, sexual orientation, socioeconomic status, race, and ethnicity.{" "}
            </p>
            <p>
              These diversity and inclusion goals will be a key focus in the grant&apos;s ongoing reporting
              requirements. Continued funding depends on your success in meeting these objectives.{" "}
            </p>
            <h6 className="bold">
              <AnchorHeading heading="ADDITIONAL INFORMATION" />
            </h6>
            <p className="bold">Financial Responsibility </p>
            <p>
              Funding is awarded to the Alzheimer’s Disease Reseach Center, not to the individual principal
              investigator. The principal investigator or a first degree relative cannot be listed as the signing
              official or financial officer or have checks sent to their attention, if awarded.{" "}
            </p>{" "}
            <p className="bold">Multiple and Overlapping Submissions </p>
            <p>
              Multiple submissions from one applicant are not permitted. This includes multiple submissions from the
              same group and/or collaborators.{" "}
            </p>
            <p className="bold">Nondiscrimination and Harassment Statement </p>
            <p>
              NACC and the Alzheimer’s Association are committed to providing an environment free from harassment and
              discrimination. NACC and the Alzheimer’s Association strictly prohibits harassment and discrimination
              based on race; creed; color; religion; sex; sexual orientation; national origin; ancestry; age; veteran
              status; citizenship status; marital status; physical or mental disabilities; pregnancy, gender identity or
              expression (including transgender status); genetic information; and any other characteristic protected by
              federal, state or local law.{" "}
            </p>
            <hr className="uk-margin-top" />
          </div>

          <>
            <div id="mailing-list" className="uk-text-center uk-width-1-1 uk-flex uk-flex-center uk-margin-large-top ">
              <p className="uk-width-xlarge uk-text-primary uk-h4">
                Sign up for the New Investigator Award Program email list to receive announcements, updates and new and
                early career opportunities.{" "}
              </p>
            </div>
            <div className="uk-flex uk-flex-center uk-margin-top">
              <div style={{ minHeight: 300 }} className="uk-width-1-2@m">
                <HubspotForm
                  region="na1"
                  portalId="19562737"
                  formId="82be4f6d-7025-4bc8-8ab8-f89d46ad673f"
                  target="hbspt-form"
                />
              </div>
            </div>
          </>
        </div>
        <ToTop />
      </SectionDefault> */}

      <div className="text-body">
        <SectionDefault subheading="Program Overview">
          <p>
            The New Investigator Award Program (NIAP), launched by the National Alzheimer&apos;s Coordinating Center
            (NACC) in partnership with the Alzheimer&apos;s Association, is a prestigious funding opportunity designed
            to foster the career development of early-career investigators in the field of Alzheimer&apos;s Disease and
            Related Dementias (AD/ADRD) research.
          </p>
          <p>
            This program aims to encourage new and early career investigators to develop innovative research projects,
            foster collaborations within their Alzheimer&apos;s Disease Research Center (ADRC) and across the ADRC
            network and support their journey toward becoming independent researchers.
          </p>
          <p>
            Building on the success of their previous collaboration, NACC and the Alzheimer&apos;s Association are again
            partnering to offer the NIAP for the 2025 funding cycle. This ongoing partnership reinforces their shared
            commitment to supporting and advancing the careers of the next generation of AD/ADRD researchers.
          </p>
          <h3 id="key-features-of-the-2025-niap">
            <AnchorHeading>Key Features of the 2025 NIAP</AnchorHeading>
          </h3>
          <ul className="uk-list uk-list-bullet">
            <li>
              <p>Up to ten (10) awards available</p>
            </li>
            <li>
              <p>$135,000 in direct costs per award</p>
            </li>
            <li>
              <p>One to two-year project duration (June 2025 through May 2027)</p>
            </li>
            <li>
              <p>Comprehensive mentorship program to support applicants through application process</p>
            </li>
            <li>
              <p>Focus on innovative, impactful research across the spectrum of AD/ADRD studies</p>
            </li>
          </ul>
          <p>
            The NIAP represents a core tenet of the missions of NACC, the Alzheimer&apos;s Association, and the ADRCs:
            funding early career investigators to drive forward understanding and treatment of AD/ADRD.
          </p>
          <p>
            <a
              href="https://files.alz.washington.edu/new-investigator-awards/2025-NIAP-FAQ.docx.pdf"
              target="_blank"
              rel="noreferrer"
            >
              View FAQs Here
            </a>
          </p>
          <ToTop />
        </SectionDefault>

        <SectionDefault subheading="Key Dates">
          <div className="uk-margin">
            <table className="uk-table uk-table-divider uk-table-middle ">
              <tbody className="text-body">
                <tr>
                  <td>NIAP Award Luncheon Session at the 2024 Fall ADRC Meeting</td>
                  <td className=" text-body uk-text-secondary bolder">October 16, 2024</td>
                </tr>
                <tr>
                  <td>
                    <a href="https://www.youtube.com/watch?v=KRryiz40kGw" target="_blank" rel="noreferrer">
                      Informational Webinar for Applicants
                    </a>
                  </td>
                  <td className=" text-body uk-text-secondary bolder">October 24, 2024</td>
                </tr>
                <tr>
                  <td>Letter of Intent and Mentor Request Deadline</td>
                  <td className=" text-body uk-text-secondary bolder">November 8, 2024, 5pm EST</td>
                </tr>
                <tr>
                  <td>Application Deadline</td>
                  <td className=" text-body uk-text-secondary bolder">January 16, 2025, 5pm EST</td>
                </tr>
                <tr>
                  <td>Application Review</td>
                  <td className=" text-body uk-text-secondary bolder">January – April 2025</td>
                </tr>
                <tr>
                  <td>Award Notifications</td>
                  <td className=" text-body uk-text-secondary bolder">May 2025 (at 2025 Spring ADRC Meeting)</td>
                </tr>
              </tbody>
            </table>
          </div>
          <ToTop />
        </SectionDefault>

        <SectionDefault subheading="Program Impact">
          <p>
            The NIAP has a proven track record of launching and advancing the careers of promising AD/ADRD researchers.
            Explore the real-world impact of our program:
          </p>
          <h3 id="niap-success-stories">
            <AnchorHeading>NIAP Past Awardees </AnchorHeading>
          </h3>
          <div>
            <ul className="uk-list uk-list-bullet">
              <li>
                <a className="" href="/nacc-productivity/2024-new-investigator-award-winners">
                  Congratulations to the 2024 NIAP Awardees
                </a>
              </li>
              <li>
                <a className="" href="/nacc-productivity/ni-award-winners-blog">
                  Discover how the NIAP has helped shape the trajectory of early-career researchers in AD/ADRD
                </a>
              </li>
              <li>
                <a className="" href="/nacc-productivity/nacc-funded-research">
                  See all NACC-funded research
                </a>
              </li>
            </ul>
          </div>

          <h3 id="hear-from-our-alumni">
            <AnchorHeading>Hear from Our Alumni</AnchorHeading>
          </h3>
          <div>
            <iframe
              src="https://www.youtube-nocookie.com/embed/i4feNnEZBdU?start=0?autoplay=0&amp;showinfo=0&amp;rel=0&amp;modestbranding=1&amp;playsinline=0"
              width="1920"
              height="1080"
              allowfullscreen
              data-uk-responsive
              data-uk-video="false"
            ></iframe>
          </div>
          <p className="uk-text-meta">
            Watch Dr. Tamar Gefen, a former NIAP awardee, share her experience and the impact of the award on her career
            in AD/ADRD research.
          </p>
          <ToTop />
        </SectionDefault>

        <SectionDefault subheading="Eligibility: Who Can Apply for the NIAP?">
          <p>Eligible candidates must be new investigators who meet the following criteria:</p>

          <ul className="uk-list uk-list-bullet">
            <li>
              <p>Are affiliated with an ADRC (see ADRC Affiliation Requirements below)</p>
            </li>
            <li>
              <p>Are post-doctoral fellows, residents, or junior faculty</p>
            </li>
            <li>
              <p>Have not been promoted beyond assistant professor rank (MD or PhD)</p>
            </li>
            <li>
              <p>Are within 10 years of their terminal degree (exceptions may be considered for career disruptions)</p>
            </li>
            <li>
              <p>Have not received an R01 grant at the time of NIAP application</p>
            </li>
            <li>
              <p>Have a position that allows for at least 10-20% dedicated time to conduct the proposed research</p>
            </li>
            <li>
              <p>Have not previously received a New Investigator Award Program (NIAP) award</p>
            </li>
          </ul>
          <h3 id="adrc-affiliation-requirements">
            <AnchorHeading>ADRC Affiliation Requirements</AnchorHeading>
          </h3>
          <p>
            Affiliation with an ADRC is defined at the discretion of each ADRC Director and may vary across the ADRC
            Program. To qualify, applicants must provide a letter from their ADRC Director confirming the following:
          </p>

          <ul className="uk-list uk-list-bullet">
            <li>
              <p>
                The applicant is affiliated with the ADRC, and this affiliation was established before October 2024 and
                is ongoing
              </p>
            </li>
            <li>
              <p>The specific nature of the affiliation, which may include but is not limited to:</p>

              <ul className="uk-list uk-list-bullet">
                <li>
                  <p>Holding a formal position at the ADRC</p>
                </li>
                <li>
                  <p>Active engagement in ADRC activities</p>
                </li>
                <li>
                  <p>Receiving or being eligible to receive a salary from the ADRC</p>
                </li>
                <li>
                  <p>Working in an ADRC-affiliated laboratory</p>
                </li>
                <li>
                  <p>Being a faculty member or clinician associated with the ADRC</p>
                </li>
                <li>
                  <p>Being a postdoctoral researcher contributing to ADRC-funded research</p>
                </li>
              </ul>
            </li>
            <li>
              <p>
                <strong>Important Notes:</strong>
              </p>

              <ul className="uk-list uk-list-bullet">
                <li>
                  <p>
                    The ADRC Director does not need to specify which criteria are met, only that the applicant is
                    considered affiliated with the ADRC
                  </p>
                </li>
                <li>
                  <p>
                    The letter must confirm that the ADRC can manage and disburse the NIAP funds to the awardee via the
                    ADRC&apos;s existing subcontract with NACC
                  </p>
                </li>
                <li>
                  <p>
                    A template for the ADRC Director&apos;s letter is available on ProposalCentral and can be downloaded{" "}
                    <a href="http://files.alz.washington.edu/new-investigator-awards/Letter-of-Support-Template_NIAP-2025.docx">
                      here.
                    </a>
                  </p>
                </li>
              </ul>
            </li>
          </ul>
          <ToTop />
        </SectionDefault>

        <SectionDefault subheading="NIAP Research Guidelines">
          <p>
            The NIAP welcomes research proposals across the entire spectrum of ongoing work within the ADRC Program.
            Areas of study are open and diverse, encompassing a wide range of approaches including, but not limited to,
            data-driven and methodological studies that rely on credible data sources.
          </p>
          <p>
            This broad scope reflects the program&apos;s commitment to fostering innovative research that can
            significantly advance our understanding of AD/ADRD.
          </p>
          <p>
            Successful NIAP projects should aim to advance AD/ADRD science through innovative, rigorous, and impactful
            research. The Program encourages proposals that meet the objectives, scope, and focus noted here.
          </p>
          <h3 id="key-objectives">
            <AnchorHeading>Key Objectives</AnchorHeading>
          </h3>

          <ul className="uk-list uk-list-bullet">
            <li>
              <p>Demonstrate scientific rigor in methodology and approach</p>
            </li>
            <li>
              <p>Advance AD/ADRD science through novel and innovative approaches</p>
            </li>
            <li>
              <p>Identify and characterize important gaps in current knowledge</p>
            </li>
            <li>
              <p>Provide novel insights rather than replicating previous studies</p>
            </li>
          </ul>
          <h3 id="research-scope">
            <AnchorHeading>Research Scope</AnchorHeading>
          </h3>
          <p>Projects may span a wide range of study types, including but not limited to:</p>

          <ul className="uk-list uk-list-bullet">
            <li>
              <p>Discovery science</p>
            </li>
            <li>
              <p>Translational research</p>
            </li>
            <li>
              <p>Clinical studies</p>
            </li>
            {/* <li>
              <p>Health equity research</p>
            </li> */}
            <li>
              <p>Care-related investigations</p>
            </li>
            <li>
              <p>Recruitment science</p>
            </li>
            <li>
              <p>Data-driven analyses</p>
            </li>
          </ul>
          <h3 id="areas-of-focus">
            <AnchorHeading>Areas of Focus</AnchorHeading>
          </h3>
          <p>Projects may focus on, but are not limited to:</p>

          <ul className="uk-list uk-list-bullet">
            <li>
              <p>Environmental exposures and their impact on AD/ADRD</p>
            </li>
            <li>
              <p>Social and structural determinants of health</p>
            </li>
            <li>
              <p>Biomarkers for early detection, diagnosis, or disease progression</p>
            </li>
            <li>
              <p>Underlying disease mechanisms</p>
            </li>
            <li>
              <p>Novel therapeutic approaches</p>
            </li>
            <li>
              <p>Psychosocial factors influencing AD/ADRD</p>
            </li>
            <li>
              <p>Recruitment science to enhance clinical study participation and diversity</p>
            </li>
            <li>
              <p>Health disparities in AD/ADRD</p>
            </li>
            <li>
              <p>Innovative approaches to participant engagement and retention</p>
            </li>
          </ul>
          <p>
            The complex nature of AD/ADRD necessitates a multidisciplinary approach to research. The NIAP encourages
            projects that draw from and integrate multiple scientific disciplines to address critical questions in the
            field. Research proposals may be rooted in various areas of expertise, including neuropathology,
            epidemiology, neurology, and psychiatry, which provide crucial insights into the biological underpinnings
            and clinical manifestations of AD/ADRD.
          </p>
          <p>
            For more information on features of a successful new investigator research project, please download and read
            the{" "}
            <a href="https://files.alz.washington.edu/new-investigator-awards/RFA_New-Investigator-Awards_2025-26.pdf">
              Request for Proposal for the NIAP
            </a>
            .
          </p>
          <ToTop />
        </SectionDefault>

        <SectionDefault subheading="Data Sources">
          <p>
            New Investigator projects may leverage any data source or study base for their proposed study but must
            defend its scientific rigor to address their research questions. This includes secondary data analysis.
          </p>
          <p>
            NIAP proposals do not require the use of NACC data. However, proposals that include plans for the
            investigator to visit and/or collaborate across and between ADRCs are strongly encouraged, including
            proposals based on the CLARiTI (Clarity in Alzheimer’s Disease and Related Dementias Research Through
            Imaging) initiative.
          </p>
          <ToTop />
        </SectionDefault>

        <SectionDefault subheading="NIAP Mentorship Program">
          <p>
            NACC and the ADRC Research Education Component (REC) Steering Committee have partnered to provide the
            NACC-REC New Investigator Award Mentorship Program. This initiative offers invaluable support and guidance
            to new and early career investigators applying for a New Investigator Award.
          </p>
          <h3 id="program-overview-1">
            <AnchorHeading>Program Overview</AnchorHeading>
          </h3>

          <ul className="uk-list uk-list-bullet">
            <li>
              <p>All NIAP applicants can request a mentor through their Letter of Intent.</p>
            </li>
            <li>
              <p>NACC and REC try to match mentors with mentees based on research expertise and background.</p>
            </li>
            <li>
              <p>The program focuses on reviewing and providing feedback on proposal drafts and specific aims.</p>
            </li>
            <li>
              <p>
                Mentors and mentees are expected to participate in two review and feedback sessions before the
                application deadline.
              </p>
            </li>
            <li>
              <p>These sessions can be conducted asynchronously to accommodate various schedules.</p>
            </li>
          </ul>

          <h3 id="key-features">
            <AnchorHeading>Key Features</AnchorHeading>
          </h3>

          <ul className="uk-list uk-list-bullet">
            <li>
              <p>Expert Guidance: Mentors are experienced researchers from across the ADRC network.</p>
            </li>
            <li>
              <p>
                Personalized Support: Mentorship is tailored to each applicant&apos;s specific research focus and needs.
              </p>
            </li>
            <li>
              <p>
                Flexible Interaction: Meetings can be conducted virtually or in-person, based on mentor and mentee
                preferences.
              </p>
            </li>
            <li>
              <p>
                Proposal Strengthening: Mentors provide constructive feedback to enhance the quality of applications.
              </p>
            </li>
          </ul>
          <h3 id="mentorship-program-highlights">
            <AnchorHeading>Mentorship Program Highlights</AnchorHeading>
          </h3>

          <ul className="uk-list uk-list-bullet">
            <li>
              <p>
                Recent surveys of program participants have demonstrated the significant value of this mentorship
                initiative:
              </p>

              <ul className="uk-list uk-list-bullet">
                <li>
                  <p>77% of applicants requested mentors, all of whom were matched by NACC and REC.</p>
                </li>
                <li>
                  <p>85.4% of mentees reported ease in connecting with their mentor for application guidance.</p>
                </li>
                <li>
                  <p>On average, mentees met with their mentors 2.7 times for review and feedback sessions.</p>
                </li>
                <li>
                  <p>80.2% of mentees felt their mentor helped strengthen their proposal.</p>
                </li>
                <li>
                  <p>
                    92.2% of applicants expressed confidence in applying the guidance received to future grant
                    applications.
                  </p>
                </li>
              </ul>
            </li>
          </ul>
          <h3 id="testimonials">
            <AnchorHeading>Testimonials</AnchorHeading>
          </h3>
          <p>Previous NIAP mentees have shared their positive experiences:</p>

          <ul className="uk-list uk-list-bullet">
            <li>
              <p>
                &quot;It was a great experience to have additional advice from faculty who are not at my home
                institution.&quot;
              </p>
            </li>
            <li>
              <p>
                &quot;I think the mentor program was crucial, in my case, since it helped me take advantage of my
                previous papers in order to use them to build my grant. I&apos;m very grateful.&quot;
              </p>
            </li>
          </ul>
          <h3 id="long-term-benefits">
            <AnchorHeading>Long-term Benefits</AnchorHeading>
          </h3>

          <ul className="uk-list uk-list-bullet">
            <li>
              <p>Participation in the mentorship program offers benefits that extend beyond the NIAP application:</p>

              <ul className="uk-list uk-list-bullet">
                <li>
                  <p>Exposure to diverse perspectives from experts outside your home institution</p>
                </li>
                <li>
                  <p>Development of grant writing skills applicable to future funding opportunities</p>
                </li>
                <li>
                  <p>Opportunity to build professional relationships within the AD/ADRD research community</p>
                </li>
                <li>
                  <p>Increased confidence in navigating the grant application process</p>
                </li>
              </ul>
            </li>
          </ul>
          <h3 id="how-to-participate">
            <AnchorHeading>How to Participate</AnchorHeading>
          </h3>
          <p>
            To request a mentor, applicants should indicate their interest on the Letter of Intent form when they begin
            the NIAP application process. The NACC and REC teams will work to match applicants with appropriate mentors
            based on the applicants’ research interests and backgrounds.
          </p>
          <p>
            We strongly encourage all applicants, especially those new to the grant writing process, to take advantage
            of this valuable opportunity. The mentorship program is designed to support applicants’ success not just in
            the NIAP application, but in their broader career as AD/ADRD researchers.
          </p>
          <div className="uk-card uk-card-primary uk-card-body uk-text-center">
            <a
              href="https://nacc.redcap.rit.uw.edu/surveys/?s=MARDP4LNWM4AXL4J"
              className="uk-text-large uk-text-center bolder uk-light"
            >
              Share Your Expertise: Become a NIAP Mentor
            </a>
          </div>
          <h4>Join Our NIAP Mentorship Program</h4>
          <p>
            NACC and the REC Steering Committee invite senior investigators from the ADRC Program to make a lasting
            impact by mentoring promising new investigators. Your guidance and expertise are needed to help guide
            tomorrow&apos;s leaders in AD/ADRD research.{" "}
          </p>
          <AccordionLite>
            <AccordionItemLite buttonText="Who Can Be a Mentor?">
              <ul className="uk-list uk-list-bullet">
                <li>ADRC investigators with R01 funding and established experience in AD/ADRD research</li>
                <li>
                  Investigators interested in sharing their expertise to foster early-career researcher development
                </li>
              </ul>
            </AccordionItemLite>
            <AccordionItemLite buttonText="Mentor Commitment">
              <ul className="uk-list uk-list-bullet">
                <li>Total time commitment: Approximately three hours per mentee</li>
                <li>At least two feedback sessions with assigned mentee(s)</li>
                <li>Review and provide constructive feedback on NIAP application materials</li>
                <li>Sessions can be conducted asynchronously for scheduling flexibility</li>
              </ul>
            </AccordionItemLite>
            <AccordionItemLite buttonText="Why Become a Mentor?">
              <ul className="uk-list uk-list-bullet">
                <li>Help shape the future of AD/ADRD research</li>
                <li>Support the development of promising early-career investigators</li>
                <li>Strengthen the ADRC research community</li>
                <li>Contribute to the program&apos;s proven track record of success</li>
              </ul>
            </AccordionItemLite>
          </AccordionLite>
          <h4>Ready to Join?</h4>
          <p>Complete our Mentor Sign Up Form by November 8, 2024:</p>
          <div className="uk-flex uk-flex-center uk-padding">
            <a
              href="https://nacc.redcap.rit.uw.edu/surveys/?s=MARDP4LNWM4AXL4J"
              className="uk-button uk-button-primary uk-margin-vertical"
            >
              Mentor Sign Up Form
            </a>
          </div>
          <p>
            For questions about becoming a mentor, contact NACC at{" "}
            <a href="mailto:info@naccdata.org">info@naccdata.org</a>.
          </p>
          <ToTop />
        </SectionDefault>

        <SectionDefault subheading="Application Process">
          <p>
            The NIAP application involves two main steps. All submissions must be made through ProposalCentral. Download
            the{" "}
            <a href="https://files.alz.washington.edu/new-investigator-awards/RFA_New-Investigator-Awards_2025-26.pdf">
              Request for Application (RFA
            </a>
            ) for detailed instructions on required documents, eligibility criteria, and submission guidelines.
          </p>
          <ol type="1" className="uk-list uk-list-decimal">
            <li>
              <p>
                <strong>Submit a Letter of Intent (LOI) by November 8, 2024, 5pm EST.</strong>{" "}
                <em className="red">LOI STAGE IS CLOSED FOR 2025 NIAP FUNDING CYCLE.</em>
              </p>
              <ul className="uk-list uk-list-bullet">
                <li>
                  <p>
                    Complete the LOI through <a href="https://proposalcentral.com/">ProposalCentral</a>
                  </p>
                </li>
                <li>
                  <p>Include: Investigator details, ADRC affiliation, project title, keywords, and brief description</p>
                </li>
                <li>
                  <p>Indicate if you&apos;d like to be matched with a mentor</p>
                </li>
              </ul>
            </li>
            <li>
              <p>
                <strong>
                  If your Letter of Intent is accepted, you will be notified via email that you are approved
                </strong>{" "}
                <strong>to submit a full application.</strong>
              </p>
            </li>
            <li>
              <p>
                <strong>Prepare Specific Aims and Research Plan</strong>
              </p>
              <ul className="uk-list uk-list-bullet">
                <li>
                  <p>Specific Aims (1 page)</p>
                </li>
                <li>
                  <p>Research Plan (6 pages total):</p>
                  <ul className="uk-list uk-list-bullet">
                    <li>
                      <p>Significance</p>
                    </li>
                    <li>
                      <p>Innovation</p>
                    </li>
                    <li>
                      <p>Approach</p>
                    </li>
                  </ul>
                </li>
                <li>
                  <p>Bibliography and References Cited (no page limit)</p>
                </li>
              </ul>
            </li>
            <li>
              <p>
                <strong>Complete Full Application in ProposalCentral by January 16, 2025, 5pm EST</strong>
              </p>
              <ul className="uk-list uk-list-bullet">
                <li>
                  <p>Enter applicant information, proposal, and budget details</p>
                </li>
                <li>
                  <p>Upload required documents:</p>
                  <ul className="uk-list uk-list-bullet">
                    <li>
                      <p>Research Plan (6 pages total)</p>
                    </li>
                    <li>
                      <p>Budget Justification and Resources (2 pages max)</p>
                    </li>
                    <li>
                      <p>ADRC Director&apos;s Letter of Support (1 page max)</p>
                    </li>
                    <li>
                      <p>Biographical Sketches (NIH-Format, 5 pages max each)</p>
                    </li>
                    <li>
                      <p>Additional Letters of Support (optional, limited to 3 letters of 1 page each)</p>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ol>
          <p>
            While this overview provides essential information, we strongly encourage all applicants to carefully review
            the detailed application instructions in the full RFA. The RFA contains comprehensive guidance on the
            application process, including:
          </p>
          <ul className="uk-list uk-list-bullet">
            <li>
              <p>Step-by-step submission instructions</p>
            </li>
            <li>
              <p>Required documents and their formats</p>
            </li>
            <li>
              <p>Specific content requirements for each application component</p>
            </li>
          </ul>
          <p>
            <a
              target="_blank"
              href="https://files.alz.washington.edu/new-investigator-awards/RFA_New-Investigator-Awards_2025-26.pdf"
              rel="noreferrer"
            >
              Download the 2025-2026 NIAP Request for Applications (RFA)
            </a>
          </p>
          <p>
            <a
              target="_blank"
              href="https://files.alz.washington.edu/new-investigator-awards/2025-NIAP-APPLICATION-INSTRUCTIONS.pdf"
              rel="noreferrer"
            >
              Download Detailed Instructions
            </a>
          </p>
          <p>
            <strong>Budget Information</strong>
          </p>
          <p>
            The NIAP offers substantial funding to support innovative AD/ADRD research projects. Here are the key budget
            details:
          </p>
          <ul className="uk-list uk-list-bullet">
            <li>
              <p>Total Award: Up to $135,000 in direct costs</p>
            </li>
            <li>
              <p>Duration: One to two years (June 2025 through May 2027)</p>
            </li>
            <li>
              <p>Indirect Costs:</p>
              <ul className="uk-list uk-list-bullet">
                <li>
                  <p>10% for awards funded by the Alzheimer&apos;s Association</p>
                </li>
                <li>
                  <p>ADRC&apos;s federally negotiated rate for NACC-funded awards</p>
                </li>
              </ul>
            </li>
          </ul>
          <p>
            Download the RFA for more information on allowable and non-allowable costs, budget preparation instructions,
            and other financial considerations for your proposal.
          </p>
          <ul className="uk-list uk-list-bullet">
            <li>
              <p>
                <a
                  href="https://files.alz.washington.edu/new-investigator-awards/RFA_New-Investigator-Awards_2025-26.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  Download the Full RFA Document
                </a>
              </p>
              <p>
                <a
                  href="https://files.alz.washington.edu/new-investigator-awards/2025-NIAP-APPLICATION-INSTRUCTIONS.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  Download Detailed Instructions
                </a>
              </p>
            </li>
            <li>
              <p>
                For specific questions about budget preparation or allowable expenses, please refer to the RFA or
                contact <a href="mailto:grantsapp@alz.org">grantsapp@alz.org</a> and/or{" "}
                <a href="mailto:info@naccdata.org">info@naccdata.org</a>.
              </p>
            </li>
          </ul>
          <h3 id="note-on-indirect-costs-and-funding-source">
            <AnchorHeading>Note on Indirect Costs and Funding Source</AnchorHeading>
          </h3>
          <p>
            The NIAP is a collaborative program between NACC and the Alzheimer&apos;s Association, which impacts how
            indirect costs are handled:
          </p>
          <ul className="uk-list uk-list-bullet">
            <li>
              <p>
                <strong>Initial Application</strong>: ProposalCentral defaults to the Alzheimer&apos;s
                Association&apos;s 10% indirect cost rate for all applications.
              </p>
            </li>
            <li>
              <p>
                <strong>Potential Rate Changes</strong>: Indirect cost rates may change based on the final funding
                source:
              </p>
              <ul className="uk-list uk-list-bullet">
                <li>
                  <p>Alzheimer&apos;s Association funding: 10% indirect cost rate (as preset in the application)</p>
                </li>
                <li>
                  <p>
                    NACC funding: If selected, the indirect cost rate will be adjusted to align with the ADRC&apos;s
                    federally negotiated indirect cost rate
                  </p>
                </li>
              </ul>
            </li>
            <li>
              <p>
                <strong>For Awards Receiving NACC Funding</strong>:
              </p>

              <ul className="uk-list uk-list-bullet">
                <li>
                  <p>
                    Applicants will be required to submit a Cover Page that aligns with NACC&apos;s sub-award to the
                    ADRC
                  </p>
                </li>
                <li>
                  <p>
                    An updated budget page reflecting the ADRC&apos;s federally negotiated indirect cost rate will be
                    required at the time of award
                  </p>
                </li>
              </ul>
            </li>
          </ul>
          <p>
            Applicants should prepare their initial budgets using the 10% indirect cost rate in ProposalCentral.
            However, please be aware that this rate may be adjusted after award decisions are made, depending on the
            funding source.
          </p>
          <ToTop />
        </SectionDefault>

        <SectionDefault subheading="Review Process">
          <ol className="uk-list uk-list-decimal" type="1">
            <li>
              <p>Initial screening by NACC and Alzheimer&apos;s Association</p>
            </li>
            <li>
              <p>Peer review by NACC Scientific Review Committee (SRC)</p>
            </li>
            <li>
              <p>Full panel discussion for top-ranked applications</p>
            </li>
            <li>
              <p>
                Final approval by NACC Steering Committee and Alzheimer&apos;s Association Medical &amp; Scientific
                Advisory Group
              </p>
            </li>
          </ol>
          <h3 id="review-criteria">
            <AnchorHeading>Review Criteria</AnchorHeading>{" "}
          </h3>
          <p>All applications will be evaluated based on the following criteria:</p>
          <ul className="uk-list uk-list-bullet">
            <li>
              <p>
                <strong>Overall Impact:</strong> The potential for the project to significantly influence relevant
                research fields
              </p>
            </li>
            <li>
              <p>
                <strong>Significance:</strong> The importance of the problem or critical hurdle to progress that the
                proposed project addresses
              </p>
            </li>
            <li>
              <p>
                <strong>Investigator(s):</strong> The qualifications of the research team
              </p>
            </li>
            <li>
              <p>
                <strong>Innovation:</strong> The novelty of the research and/or methods
              </p>
            </li>
            <li>
              <p>
                <strong>Approach:</strong> The overall scientific strategy, methodology, and analyses
              </p>
            </li>
            <li>
              <p>
                <strong>Environment:</strong> The adequacy of the research setting
              </p>
            </li>
            <li>
              <p>
                <strong>Budget &amp; Resources:</strong> Quality and suitability of the proposed budget and resources
              </p>
            </li>
            <li>
              <p>
                <strong>Additional Criteria</strong>
              </p>
              <ul className="uk-list uk-list-bullet">
                <li>
                  <p>Protections for Human Subjects</p>
                </li>
                {/* <li>
                  <p>
                    Inclusion of underrepresented populations, including racial, ethnic, gender/sex, and other
                    populations
                  </p>
                </li> */}
              </ul>
            </li>
          </ul>
          <p>
            For detailed information on the NIAP review process, please consult the full Request for Applications (RFA):
          </p>
          <ul className="uk-list uk-list-bullet">
            <li>
              <p>
                <a href="https://files.alz.washington.edu/new-investigator-awards/RFA_New-Investigator-Awards_2025-26.pdf">
                  Download the 2025 NIAP Request for Applications (RFA)
                </a>
              </p>
            </li>
          </ul>
          <ToTop />
        </SectionDefault>

        <SectionDefault subheading="Resources">
          <ul className="uk-list uk-list-bullet">
            <li>
              <p>
                NIAP Webinar – October 24, 2024
                <br />
                <a href="https://www.youtube.com/watch?v=KRryiz40kGw">Watch Recording</a>
                <br />
                <a href="https://files.alz.washington.edu/new-investigator-awards/NIAP-Webinar-Presentation-10242024.pdf">
                  View Presentation Slides
                </a>
              </p>
            </li>
            <li>
              <p>
                <a href="https://files.alz.washington.edu/new-investigator-awards/RFA_New-Investigator-Awards_2025-26.pdf">
                  NIAP Request for Applications (RFA) Document
                </a>
              </p>
            </li>
            <li>
              <p>
                <a
                  href="https://files.alz.washington.edu/new-investigator-awards/2025-NIAP-APPLICATION-INSTRUCTIONS.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  Download Detailed Instructions
                </a>
              </p>
            </li>
            <li>
              <p>
                <a href="https://proposalcentral.com/">ProposalCentral Application Portal</a>
              </p>
            </li>
            <li>
              <p>
                <a href="http://files.alz.washington.edu/new-investigator-awards/Letter-of-Support-Template_NIAP-2025.docx">
                  ADRC Director Letter of Support Template
                </a>
                <p className="uk-text-meta">
                  Note: If using the Chrome browser, you may receive an error message when downloading this Word file,
                  but you can override the error by selecting “download insecure file.” Downloading in another browser
                  such as Firefox or Edge may also work.{" "}
                </p>
              </p>
            </li>
            <li>
              <p>
                <a
                  href="https://files.alz.washington.edu/new-investigator-awards/2025-NIAP-FAQ.docx.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Frequently Asked Questions
                </a>
              </p>
            </li>
          </ul>
          <ToTop />
        </SectionDefault>

        <SectionDefault subheading="Questions? We're Here to Help">
          <p>
            We encourage applicants to reach out with any questions or concerns about the NIAP application process or
            eligibility requirements. Our team is committed to supporting you throughout your application journey.
          </p>
          <p>
            For inquiries about the application process, ProposalCentral, general program information, eligibility, the
            NIAP Mentorship Program, contact: <a href="mailto:grantsapp@alz.org">grantsapp@alz.org</a> and{" "}
            <a href="mailto:info@naccdata.org">info@naccdata.org</a>.
          </p>
          <p>
            <strong>Subscribe to NIAP Updates</strong>
          </p>

          {/*  HubSpot Mailing List Form */}
          <>
            <div id="mailing-list" className="uk-text-center uk-width-1-1 uk-flex uk-flex-center uk-margin-large-top ">
              <p className="uk-width-xlarge uk-text-primary uk-h4">
                Sign up for the New Investigator Award Program email list to receive announcements, updates and new and
                early career opportunities.{" "}
              </p>
            </div>
            <div className="uk-flex uk-flex-center uk-margin-top">
              <div style={{ minHeight: 300 }} className="uk-width-1-2@m">
                <HubspotForm
                  region="na1"
                  portalId="19562737"
                  formId="82be4f6d-7025-4bc8-8ab8-f89d46ad673f"
                  target="hbspt-form-1"
                />
              </div>
            </div>
          </>
        </SectionDefault>
      </div>
    </GlobalLayout>
  );
}
